export default {
  namespaced: true,
  state: {
    component: "",
    videoIsPlaying: false,
    videoId: null,
    productId: null,
  },
  actions: {
    setComponentName({ commit, dispatch }, name) {
      //* Compoenet needs to register inside the UiModal first
      commit("SET_COMPONENT_NAME", name);

      //* Triger tracking for Renew, Invoice and other modals
      switch (name) {
        case "modal1":
          name = "View Modal 1";
          break;
        case "modalVideo":
          name = "Modal Video";
          break;
        case "modalProduct":
          name = "Modal Product";
          break;
        case "modal2":
          name = "View modal 2";
          break;

        default:
          return;
      }
      //* Track open modal
      // dispatch("purl/purlTracking", name, { root: true });
    },
    setVideoIsPalying({ commit }, isPlaying) {
      commit("SET_VIDEO_IS_PLAYING", isPlaying);
    },
    setVideoId({ commit }, videoId) {
      commit("SET_VIDEO_ID", videoId);
    },
    setProductId({ commit }, productId) {
      commit("SET_PRODUCT_ID", productId);
    },
  },
  mutations: {
    SET_COMPONENT_NAME(state, name) {
      state.component = name;
    },
    SET_VIDEO_IS_PLAYING(state, isPlaying) {
      state.videoIsPlaying = isPlaying;
    },
    SET_VIDEO_ID(state, videoId) {
      state.videoId = videoId;
    },
    SET_PRODUCT_ID(state, productId) {
      state.productId = productId;
    },
  },

  getters: {},
};
